import ROUTES from "@lib/constants/Routes";
import { IRouteConfig } from "@lib/types/Routes";
import { AuthRoles } from "@lib/types/Auth";
import { FaBell, FaUser } from "react-icons/fa";
import { BiSolidDashboard } from "react-icons/bi";

const adminManagementRoutesConfig: IRouteConfig[] = [
  {
    id: ROUTES.ADMIN_MANAGEMENT.DASHBOARD,
    url: ROUTES.ADMIN_MANAGEMENT.DASHBOARD,
    title: "Admin Management Dashboard",
    messageId: "sidebar.dashboard",
    type: "item",
    icon: <BiSolidDashboard />,
    permittedRole: AuthRoles.Admin,
  },

  // don't show in sidebar
  {
    id: "myProfile",
    title: "My Profile",
    messageId: "sidebar.myProfile",
    type: "item",
    url: ROUTES.MY_PROFILE.LIST,
    icon: <FaUser />,
    dontShowInSidebar: true,
    children: [
      {
        id: ROUTES.MY_PROFILE.DETAIL_TAB,
        url: ROUTES.MY_PROFILE.DETAIL_TAB,
        title: "My Profile",
        messageId: "sidebar.myProfile",
        paramKey: ROUTES.URL_PARAMS.TAB,
        type: "item",
        dontShowInSidebar: true,
      },
    ],
  },
  {
    id: "notifications",
    title: "Notifications",
    messageId: "sidebar.notifications",
    type: "item",
    url: ROUTES.NOTIFICATIONS.LIST,
    icon: <FaBell />,
    dontShowInSidebar: true,
  },
];

export default adminManagementRoutesConfig;
